






































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  inject,
} from '@vue/composition-api'

import { createTextbook } from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'
import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'CreateTextbook',
  components: {
    CloseButton,
  },
  props: {
    textbook: Object,
  },
  setup(props, context) {
    const CreateTextbookForm = ref(null)
    const data = reactive({
      valid: true,
      name: '',
      nameRules: [(v: string) => !!v || 'name.required'],
    })

    const loading = ref(false)
    const $alert = inject(alertSymbol) as Function

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = CreateTextbookForm.value
      form.validate()
      loading.value = true
      try {
        const createdTextbook = await createTextbook(data.name)
        loading.value = false
        $alert({ text: context.root.$t('textbook.created'), type: 'success' })
        context.emit('textbook-created', createdTextbook)
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      ...toRefs(data),
      loading,
      CreateTextbookForm,
      submit,
    }
  },
})
